import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Logger } from '@upe/logger';
import { NotificationService } from '@upe/ngx-notification';

import 'rxjs/add/observable/of';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/skipWhile';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';

export enum HttpMethods {
  GET,
  POST,
  DELETE,
  PUT,
  PATCH,
}

export abstract class HttpService {

  public static BACKEND_BASE_URL: string = '';

  public static REQUEST_ERROR_MSG: string = 'Fataler Fehler bei der Komunikation mit dem Server!';

  public static HEADERS: HttpHeaders = new HttpHeaders();

  protected readonly logger: Logger = new Logger();

  private _getObserver: Map<string, Observable<any>> = new Map();

  public constructor(
    private _http: HttpClient,
    private _notification: NotificationService,
    protected readonly _path: string,
  ) {
  }

  public getBackendBaseUrl(): string {
    return HttpService.BACKEND_BASE_URL;
  }

  public getHeaders(): HttpHeaders {
    return HttpService.HEADERS;
  }

  public getRequestErrorMsg(): string {
    return HttpService.REQUEST_ERROR_MSG;
  }

  protected _get<T = any>(url: string): Observable<T | null> {
    let observable: Observable<T | null>;
    if (this._getObserver.has(url)) {
      observable = this._getObserver.get(url) as any;
    } else {
      observable = this.requestHandler<T>(HttpMethods.GET, url)
        .do(() => this._getObserver.delete(url))
        .share();
      this._getObserver.set(url, observable);
    }

    return observable;
  }

  protected _delete<T = any>(url: string): Observable<T | null> {
    return this.requestHandler<T>(HttpMethods.DELETE, url);
  }

  protected _put<T = any>(url: string, body: any): Observable<T | null> {
    return this.requestHandler<T>(HttpMethods.PUT, url, body);
  }

  protected _post<T = any>(url: string, body: any): Observable<T | null> {
    return this.requestHandler<T>(HttpMethods.POST, url, body);
  }

  protected _patch<T = any>(url: string, body: any): Observable<T | null> {
    return this.requestHandler<T>(HttpMethods.PATCH, url, body);
  }

  private requestHandler<T>(method: HttpMethods, url: string, body?: any): Observable<T | null> {
    this.logger.info('create request', {
      Smethod: HttpMethods[method], method, url, body,
    });
    const request: HttpRequest<T> = new HttpRequest(
      HttpMethods[method], this.getBackendBaseUrl() + this._path + url,
      body,
      { headers: this.getHeaders() },
    );

    return this._http.request(request)
      .do((event: HttpEvent<T>) => {
        this.logger.info(
          `${HttpMethods[method]}(${this._path + url})`,
          HttpEventType[event.type],
          body,
        );
      })
      .skipWhile((event: HttpEvent<T>) => !(event instanceof HttpResponse))
      .map((event: HttpEvent<T>) => {

        // TODO : handel http status codes

        if (event instanceof HttpResponse) {
          return event.body;
        }

        this.logger.data('HttpEvent', event);
        throw new Error('unexpected http event');
      })
      .catch((err: Error) => {
        this.logger.error('http', err.message);
        this._notification.error(this.getRequestErrorMsg());

        return Observable.of(null);
      }).do((result: T | null) => this.logger.data(`${request.method}(${request.url})`, result));
  }

}
